import { useEffect, useState } from 'react';

const IDLE_TIMEOUT_MS = 1500;
const FALLBACK_DELAY_MS = 300;

/**
 * False on the first render and true once the browser is idle after the first paint (at the latest
 * after `IDLE_TIMEOUT_MS`). Gates secondary reads so that they do not compete with the data of the
 * main view at start-up.
 */
export function useWhenIdle(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (typeof requestIdleCallback === 'function') {
      const handle = requestIdleCallback(() => setReady(true), { timeout: IDLE_TIMEOUT_MS });
      return () => cancelIdleCallback(handle);
    }
    const handle = setTimeout(() => setReady(true), FALLBACK_DELAY_MS);
    return () => clearTimeout(handle);
  }, []);
  return ready;
}
